import React from "react";
import type { ProgressProps } from "antd";
import { Progress } from "antd";
import Color from "colorjs.io";

const startColor = new Color("#FF4D4F");
const endColor = new Color("#52C41A");
const rangeColor = startColor.range(endColor);
const colorByScore = (score: number) => rangeColor(score / 100).toString({ format: "hex" });
const conicColors: ProgressProps["strokeColor"] = {
  "0%": "#FF4D4F",
  "15%": "#FF7A45",
  "30%": "#FFA940",
  "45%": "#FADB14",
  "60%": "#A0D911",
  "75%": "#73D13D",
  "100%": "#52C41A",
};

interface CircularGaugeProps {
  value: number;
  label?: string;
  size?: "small" | "default" | "large";
  className?: string;
}

const CircularGauge: React.FC<CircularGaugeProps> = ({ value, label, size = "default", className = "" }) => {
  const color = colorByScore(value);

  // Size mappings
  const sizeMap = {
    small: {
      width: 60,
      strokeWidth: 8,
      valueFontSize: 16,
      labelFontSize: 12,
    },
    default: {
      width: 90,
      strokeWidth: 10,
      valueFontSize: 20,
      labelFontSize: 14,
    },
    large: {
      width: 120,
      strokeWidth: 12,
      valueFontSize: 24,
      labelFontSize: 16,
    },
  };

  const { width, strokeWidth, valueFontSize, labelFontSize } = sizeMap[size];

  return (
    <div className={`relative ${className}`} style={{ width, height: width }}>
      <Progress
        type="circle"
        percent={value}
        size={width}
        strokeColor={conicColors}
        strokeWidth={strokeWidth}
        format={() => (
          <div className="flex flex-col items-center justify-center">
            <div style={{ fontSize: valueFontSize, color, fontWeight: "bold", lineHeight: 1 }}>{value}</div>
            {label && <div style={{ fontSize: labelFontSize, color, lineHeight: 1.2 }}>{label}</div>}
          </div>
        )}
      />
    </div>
  );
};

export default CircularGauge;

